import main from './page-layout';
export default main;